import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-combination-chart',
	templateUrl:'./AgCombinationChartPluginCompPage.html',
	styles: [],
	styleUrls:['./AgCombinationChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgCombinationChartPluginCompPage
{
	mdContent_706 = `\`\`\`java
import com.jwebmp.plugins.agcharts.AgCombinationChart;
\`\`\``;
}
